const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FAF7F1',
  },
  dataContainer: {
    width: '793px',
    height: '786px',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    padding: '20px',
  },
  header: {
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '6.2rem',
  },
  textContent: {
    fontSize: '18px',
    fontWeight: 400,
    padding: '30px',
    marginRight: '70px',
    marginLeft: '70px',
  },
  linkButton: {
    height: '48px',
    padding: '12px 24px 12px 24px',
    borderRadius: '50px',
    marginRight: '8px',
    backgroundColor: '#EF4821',
    color: 'white',
    border: 'none',
    marginTop: '10px',
    fontSize: '16px',
    fontWeight: 500,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#de4723',
    },
  },
  divider: {
    width: '100%',
    marginTop: '60px',
    border: '1px dashed #D1D1D1',
    marginBottom: '24px',
  },
  newsLetterText: {
    fontSize: '16px',
    fontWeight: '500',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
